
/* styles */
require("!!../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-64cf7988&scoped=true!sass-loader?sourceMap!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=styles&index=0!./route-resume.vue")

var Component = require("!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./route-resume.js"),
  /* template */
  require("!!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-64cf7988!../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./route-resume.vue"),
  /* scopeId */
  "data-v-64cf7988",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/route-resume.vue
// module id = 1887
// module chunks = 1